export { };

declare global {
  interface String {
    isUrl(): boolean;
    toTitleCase();
  }
}

String.prototype.isUrl = function (this: string) {
  const s = this;
  const regexp = /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/;
  return regexp.test(s);
};

String.prototype.toTitleCase = function (this: string) {
  const str = this;
  return str.toLowerCase().split(' ').map((word) => {
    return (word.charAt(0).toUpperCase() + word.slice(1));
  }).join(' ');
};
